import * as React from 'react';
import { SVGProps } from 'react';

const IconFlagStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.333 6 13 10H5v4H3V2h10l-1.667 4zM10 8H5V4h5l-.833 2L10 8z"
    />
  </svg>
);
export default IconFlagStrokedSizeS;
